<div
	[matMenuTriggerFor]="projectContextMenu"
	[style.left]="projectContextMenuPosition.x"
	[style.top]="projectContextMenuPosition.y"
	#projectContextMenuTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
<mat-dialog-content>
	<div class="searchWrapper flex flex-shrink-0 flex-col justify-stretch">
		<div class="searchInput flex flex-col items-start justify-center px-2">
			<mat-form-field
				appearance="fill"
				class="mat-form-field-compact mat-form-field-no-hint w-full"
			>
				<input
					[formControl]="searchinput"
					cdkFocusInitial
					ignoreAutocomplete
					matInput
					tabindex="0"
					type="text"
				>
				<div
					class="flex-center h-full"
					matSuffix
				>
					<mat-icon inline>search</mat-icon>
				</div>
			</mat-form-field>
		</div>
		<app-loader
			[enableCircle]="true"
			[isActive]="this.isLoading$ | async"
			[width]="20"
		></app-loader>
		<cdk-virtual-scroll-viewport
			[maxBufferPx]="800"
			[minBufferPx]="300"
			[style.height.px]="380"
			itemSize="40"
		>
			<mat-list
				class="pb-8"
				dense
				role="listbox"
			>
				<ng-container
					*cdkVirtualFor="let entry of this.data$filtered | async; let last = last; let first = first; trackBy: trackId"
				>
					<mat-divider *ngIf="entry.entityName === 'client' && !first"></mat-divider>
					<ng-container
						*ngTemplateOutlet="
              entry.entityName === 'client' ? clientItem : entry.entityName === 'project' ? projectItem : null;
              context: { entity: entry }
            "
					></ng-container>
				</ng-container>
			</mat-list>
		</cdk-virtual-scroll-viewport>
	</div>
</mat-dialog-content>
<mat-dialog-actions
	[matTooltip]="'workspace.errors.admin-create-project' | translate"
	[matTooltipDisabled]="this.workspace$canManageProject | async"
	class="mat-action-filled"
>
	<button
		(click)="createProjectDialog()"
		[disabled]="isLoading$ | async"
		*ngIf="workspace$canManageProject | async"
		class="mat-button-filled"
		color="primary"
		mat-flat-button
	>
		{{ 'project.create' | translate }}
	</button>
</mat-dialog-actions>
<mat-menu #projectContextMenu="matMenu">
	<ng-template
		let-project
		matMenuContent
	>
		<div class="flex flex-col gap-1">
			<button
				(click)="$event.stopPropagation(); togglePinnedProject(project.id)"
				mat-menu-item
			>
				<mat-icon inline>star</mat-icon>
				{{ (this.isPinned(project.id) ? 'project.fav-disable' : 'project.fav-enable') | translate }}
			</button>
			<a
				[routerLink]="['/settings/projects', project.id]"
				*ngIf="!project.useAsDefault"
				mat-menu-item
				matDialogClose
			>
				<mat-icon inline>open_in_new </mat-icon>
				{{ 'project.open' | translate }}
			</a>
		</div>
	</ng-template>
</mat-menu>
<ng-template
	#clientItem
	let-entry="entity"
>
	<h3 matSubheader>
		<span class="--client-title">{{
			entry.id === 'internal' ? (entry.name | translate) : (entry | defaultEntityTranslate: 'client' : 'client.none')
		}}</span>
	</h3>
</ng-template>
<ng-template
	#projectItem
	let-project="entity"
>
	<tg-client-project-entry
		(contextMenu)="onContextMenu($event)"
		(selectItem)="onSelectItem($event)"
		(selectTaskItem)="onSelectTaskItem($event)"
		[entry]="project"
		[tooltipTemplate]="projectPickerTooltip"
	></tg-client-project-entry>
</ng-template>

<ng-template
	#projectPickerTooltip
	let-project="project"
	let-tags="tags"
	let-task="task"
>
	<div class="flex flex-row">
		<div class="my-2 flex flex-col space-y-2 px-2.5 wflex-[1_0_220px]">
			<div class="space-y-1">
				<h3
					class="mat-hint text-sm italic"
					translate
				>
					client.single
				</h3>
				<div class="font-semibold">
					{{ project?.client | defaultEntityTranslate: 'client' : 'client.none' }}
				</div>
			</div>
			<div class="space-y-1">
				<h3
					class="mat-hint text-sm italic"
					translate
				>
					project.single
				</h3>
				<div class="font-semibold">{{ project | defaultEntityTranslate: 'project' : 'project.none' }}</div>
			</div>
			<div
				*ngIf="(project | projectProxy)?.description as desc"
				class="space-y-1"
			>
				<h3
					class="mat-hint text-sm italic"
					translate
				>
					Description
				</h3>
				<div>{{ desc | truncate: 120 }}</div>
			</div>
			<ng-container *ngIf="tags && tags.length > 0">
				<div class="space-y-1">
					<h3
						class="mat-hint text-sm italic"
						translate
					>
						tag.plural
					</h3>
					<div class="flex flex-wrap gap-2">
						<div
							*ngFor="let item of tags; trackBy: trackId"
							class="mbg-card pointer-events-none h-6 cursor-default select-none truncate rounded-full px-2.5 text-base leading-6"
						>
							{{ item.name }}
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</ng-template>
